import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CustomMediaComponent } from './custom-media.component';

@NgModule({
  imports: [CommonModule],
  declarations: [CustomMediaComponent],
  exports: [CustomMediaComponent],
})
export class CustomMediaModule {
  static forRoot(): ModuleWithProviders<CustomMediaModule> {
    return {
      ngModule: CustomMediaModule,
    };
  }
}
